// extracted by mini-css-extract-plugin
export default {"matrix":"nCt_"};